const reportWebVitals = (onPerfEntry?: any) => {
  // This function can be used to report web vitals if needed
  // Currently not implemented to avoid web-vitals dependency
};

export default reportWebVitals;
